const SMALLER_SCREEN_BREAKPOINT = 768;

export type DeviceViewport = {
    width: number;
    height: number;
};

export function getDeviceViewport(): DeviceViewport {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}

export function isSmallerScreen(
    width: number = getDeviceViewport().width,
    height: number = getDeviceViewport().height,
): boolean {
    const isBelowBreakpoint = width < SMALLER_SCREEN_BREAKPOINT || height < 600;
    const isPortrait = height > width && height > SMALLER_SCREEN_BREAKPOINT;

    return isBelowBreakpoint || isPortrait;
}
